import { message, PageHeader, Tag, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, TableItem, dineroDisabledMask } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ModalGenerarFacturaVariasRemisiones from "./ModalGenerarFacturaVariasRemisiones/ModalGenerarFacturaVariasRemisiones";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select
moment.locale("es");

class FacturarVariasRemisiones extends Component {
  state = {
    todasVentas: [],
    loading: false,
    modalCancelacion: false,
    modalCancelacionId: null,
    modalEnvios: false,
    modalEnviosId: null,
    ventasSeleccionadas: [],
    subtotal: 0,
    total: 0,
    modalDatosFacturarVariasRemisiones: 0,
    filtrosProyectos: [],
    modalVerFacturarVariasRemisiones: false,
    modalVerFacturarVariasRemisionesId: null
  };
  componentDidMount() {
    this.consultarDatosFacturarVariasRemisiones();
  }

  consultarDatosFacturarVariasRemisiones() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/selectDatosFacturarVariasRemisiones",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          let filtrosProyectos = res.data.proyectos.map(valueProyecto => {
            return {
              text: valueProyecto.nombre,
              value: valueProyecto._id.toString()
            }
          })
          this.setState({
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasVentas: res.data.ventas.map((value) => {
              let numero = ''
              if (value.remision) {
                numero += (value.remisionSerie ? value.remisionSerie : 'R') + ' ' + value.remisionNumero
              }
              if (value.factura) {
                if (numero !== '') {
                  numero += ' '
                }
                numero += (value.facturaSerie ? value.facturaSerie : 'F') + ' ' + value.facturaNumero
              }
              return {
                ...value,
                fechaVenta: value.fechaFactura
                  ? value.fechaFactura
                  : value.fechaRemision,
                numero: numero,
                moneda: value.moneda.abreviacion,
                cliente: (value.cliente.persona ? value.cliente.razonSocial : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)) + " - " + value.cliente.rfc,
              };
            }),
            filtrosProyectos
          });
        } else {
          message.error('Hubo un error y no se cargaron los datos')
        }
      });
  }

  atras() {
    this.props.history.goBack();
  }

  onSelectChange = (ventasSeleccionadas) => {

    let total = 0
    let subtotal = 0
    let clienteId
    let contado
    let monedaId
    let proyectoId
    let diferenteMoneda = false
    let diferenteCliente = false
    let diferenteContado = false
    let creditoPagado = false
    let diferenteProyecto = false
    for (const valueVentaId of ventasSeleccionadas) {
      const venta = this.state.todasVentas.find(valueVentaTT => valueVentaTT._id.toString() === valueVentaId.toString())
      if (!monedaId && !clienteId && !contado && !proyectoId) {
        monedaId = venta.monedaId.toString()
        clienteId = venta.clienteId.toString()
        contado = venta.contado
        proyectoId = venta.proyectoId.toString()
        total += venta.totalPagar
        subtotal += venta.subtotal
      } else {

        if (monedaId !== venta.monedaId.toString()) {
          diferenteMoneda = true
        } else {

          total += venta.totalPagar
          subtotal += venta.subtotal
        }

        if (clienteId !== venta.clienteId.toString()) {
          diferenteCliente = true
        }
        if (contado !== venta.contado) {
          diferenteContado = true
        }

        if (proyectoId !== venta.proyectoId.toString()) {
          diferenteProyecto = true
        }

      }
      if (venta.contado === 2 && (venta.estadoPago !== 0 || venta.totalPagado !== 0)) {
        creditoPagado = true
      }
    }

    if (diferenteMoneda) {
      return message.warning('Las ventas necesitan ser de la misma moneda')
      // total = 0
      // subtotal = 0
    }

    if (diferenteCliente) {
      return message.warning('Las ventas necesitan ser del mismo cliente')
    }

    if (diferenteContado) {
      return message.warning('Las ventas necesitan ser todas de contado o todas de crédito sin pagos')
    }

    if (creditoPagado) {
      return message.warning('Las ventas de crédito no pueden tener pagos')
    }

    if (diferenteProyecto) {
      return message.warning('Las ventas necesitan ser del mismo proyecto')
    }

    this.setState({ ventasSeleccionadas, total, subtotal });
    if (ventasSeleccionadas.length === 1) {
      message.success(`Se ha seleccionado ${ventasSeleccionadas.length} venta`)
    } else if (ventasSeleccionadas.length > 1) {
      message.success(`Se han seleccionado ${ventasSeleccionadas.length} ventas`)
    }
  }

  abrirDatosFacturarVariasRemisiones() {
    if (this.state.ventasSeleccionadas.length > 0) {
      let modalDatosFacturarVariasRemisiones = false
      let clienteId
      let contado
      let monedaId
      let proyectoId
      for (const valueVentaId of this.state.ventasSeleccionadas) {
        const venta = this.state.todasVentas.find(valueVentaTT => valueVentaTT._id.toString() === valueVentaId.toString())
        if (!monedaId && !clienteId && !contado && !proyectoId) {
          monedaId = venta.monedaId.toString()
          clienteId = venta.clienteId.toString()
          contado = venta.contado
          proyectoId = venta.proyectoId.toString()
          modalDatosFacturarVariasRemisiones = true
        } else {

          if (monedaId !== venta.monedaId.toString()) {
            modalDatosFacturarVariasRemisiones = false
            message.warning('Las ventas necesitan ser de la misma moneda')
          }

          if (clienteId !== venta.clienteId.toString()) {
            modalDatosFacturarVariasRemisiones = false
            message.warning('Las ventas necesitan ser del mismo cliente')
          }
          if (contado !== venta.contado) {
            modalDatosFacturarVariasRemisiones = false
            message.warning('Las ventas necesitan ser todas de contado o todas de crédito sin pagos')
          }

          if (proyectoId !== venta.proyectoId.toString()) {
            modalDatosFacturarVariasRemisiones = false
            message.warning('Las ventas necesitan ser del mismo proyecto')
          }

        }
      }

      if(monedaId !== "60c7e4396465ad440c41c15a"){
        message.warning('Solo se pueden facturar remisiones en moneda nacional')
        modalDatosFacturarVariasRemisiones = false
      }
      if(modalDatosFacturarVariasRemisiones){
        this.setState({ modalDatosFacturarVariasRemisiones });
      }
    } else {
      message.warning('Selecciona al menos una venta para generar la factura')
    }

  }

  cerrarDatosFacturarVariasRemisiones() {
    this.setState({ modalDatosFacturarVariasRemisiones: false })
    this.consultarDatosFacturarVariasRemisiones();
  }

  onFacturaGenerada() {
    this.setState({ modalDatosFacturarVariasRemisiones: false, ventasSeleccionadas: [], subtotal: 0, total: 0 })
    this.consultarDatosFacturarVariasRemisiones();
  }


  render() {
    const columns = [
      {
        title: "R / OC",
        dataIndex: "numero",
        key: "numero",
        buscar: "numero",
        sorter: true,
        render: (_, record) => (
          <div>
            <div style={{ fontSize: "12px"}}>
             {record.numero}
            </div>
           {record.ordenDeCompra && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                OC: {record.ordenDeCompra}
              </div>
            )}
          </div>
        ),
        width: 100,
        ellipsis: true,
      },
      {
        title: "OC",
        dataIndex: "ordenDeCompra",
        key: "ordenDeCompra",
        buscar: "ordenDeCompra",
        responsive: [],
        width: 0,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        filters: this.state.filtrosProyectos,
        sorter: (a, b) => {
          if (a.proyecto.nombre < b.proyecto.nombre) {
            return -1;
          }
          if (a.proyecto.nombre > b.proyecto.nombre) {
            return 1;
          }
          return 0;
        },
        render: (value) => value.nombre,
        onFilter: (value, record) => record.proyectoId.toString().indexOf(value) === 0,
        width: 160,
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        width: 200,
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        defaultSortOrder: 'descend',
        sorter: true,
        render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
        width: 120,
        ellipsis: true,
        align: "center",
      },
      {
        title: "Subtotal / Total",
        dataIndex: "subtotal",
        key: "subtotal",
        responsive: ["md"],
        sorter: true,
        buscar: "subtotal",
        render: (_, record) => (
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: "14px", color: "#666" }}>
             {dineroDisabledMask(record.subtotal)} {record.moneda}
            </div>
            <div style={{ fontWeight: "bold", fontSize: "13px" }}>
             {dineroDisabledMask(record.total)} {record.moneda}
            </div>
          </div>
        ),
        width: 150,
        ellipsis: true,
        align: "right",
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: true,
        buscar: "total",
        responsive: [],
        width: 0,
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        responsive: ["md"],
        render: (value) => {
          if (value === 0) {
            return <Tag color="red">Cancelada</Tag>;
          }
          if (value === 1) {
            return <Tag color="blue">Sin entregar</Tag>;
          }
          if (value === 2) {
            return <Tag color="orange">Entregado par.</Tag>;
          }
          if (value === 3) {
            return <Tag color="green">Entregado</Tag>;
          }
        },
        width: 140,
        ellipsis: true,
      },
    ];
    return (
      <>
        <PageHeader
          title={`Facturar Remisiones ${(this.state.subtotal !== 0 && this.state.total !== 0) ? (' - Subtotal: ' + dineroDisabledMask(this.state.subtotal) + '  Total: ' + dineroDisabledMask(this.state.total)) : ''}`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="abrirDatosFacturarVariasRemisiones"
              onClick={this.abrirDatosFacturarVariasRemisiones.bind(this)}
            >
              Datos Factura
            </ButtonItem>
          }
        />
        <TableItem
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/verVenta", { id: record._id });
              },
            };
          }}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasVentas}
          rowSelection={{
            selectedRowKeys: this.state.ventasSeleccionadas,
            onChange: this.onSelectChange.bind(this),
          }}
          columns={columns}
          pagination={false}
        />
        <ModalGenerarFacturaVariasRemisiones
          visible={this.state.modalDatosFacturarVariasRemisiones}
          cerrarGenerarFacturaVariasRemisiones={this.cerrarDatosFacturarVariasRemisiones.bind(this)}
          onFacturaGenerada={this.onFacturaGenerada.bind(this)}
          ventasIds={this.state.ventasSeleccionadas}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    certificada: state.empresa.certificada,
    envios: state.empresa.envios,
    permisoAgregarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
      )?.activado,
    permisoCancelarVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6472d37f4b2da7c85c1a8cff"
      )?.activado,
    permisoEntregarInsumosVenta:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "615ccbaff30e81b54183cf71"
      )?.activado,
  };
};

export default connect(mapStateToProps)(FacturarVariasRemisiones);
